module.exports = __webpack_public_path__ + "static/img/product_images_12_h5_zh.87398a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_12_h5_zh.png
// module id = /mbI
// module chunks = 34